import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Actions\Answers\ScoreAnswer::__invoke
* @see app/Actions/Answers/ScoreAnswer.php:17
* @route '/scoring/{answer}'
*/
const ScoreAnswer = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: ScoreAnswer.url(args, options),
    method: 'patch',
})

ScoreAnswer.definition = {
    methods: ["patch"],
    url: '/scoring/{answer}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Actions\Answers\ScoreAnswer::__invoke
* @see app/Actions/Answers/ScoreAnswer.php:17
* @route '/scoring/{answer}'
*/
ScoreAnswer.url = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { answer: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { answer: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            answer: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        answer: typeof args.answer === 'object'
        ? args.answer.id
        : args.answer,
    }

    return ScoreAnswer.definition.url
            .replace('{answer}', parsedArgs.answer.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Actions\Answers\ScoreAnswer::__invoke
* @see app/Actions/Answers/ScoreAnswer.php:17
* @route '/scoring/{answer}'
*/
ScoreAnswer.patch = (args: { answer: number | { id: number } } | [answer: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: ScoreAnswer.url(args, options),
    method: 'patch',
})

export default ScoreAnswer